<template>
  <div>
    <div class="form-row">
        <div class="form-group col-md-2">
        <label for="">姓</label>
        <input type="text" class="form-control" v-model="lastName">
      </div>
      <div class="form-group col-md-2">
        <label for="">名</label>
        <input type="text" class="form-control" v-model="firstName">
      </div>
       <div class="form-group col-md-2">
        <label for="">職稱</label>
        <select name="" id="" class="form-control" v-model="title">
          <option v-for="item in jobTitle" :value="item.id">{{ item.name }}</option>
        </select>
        <!-- <input type="text" class="form-control"> -->
      </div>
      <div class="form-group col-md-2">
        <label for="">單位</label>
        <select name="" id="" class="form-control" v-model="department">
          <option v-for="item in departments" :value="item.id">{{ item.name }}</option>
        </select>
      </div>
       <div class="form-group col-md-2">
        <label for="">警員代碼</label>
        <input class="form-control" type="text" v-model="barcode"/>
      </div>
      <div class="form-group col-md-2">
        <label for="">後台操作權限</label>
        <select name="" id="" class="form-control" v-model="serverPrivilege2">
          <option v-for="item in serverPrivilege2Group" :value="item.id">{{ item.name }}</option>
        </select>
      </div>
    </div>

    <div class="form-row">
      <div class="form-check" v-if="rowData.is_superuser === false">
        <label for="" class="form-check-label">
          <input type="checkbox" class="form-check-input" v-model="isSuperuser">
          <span>能否後台設定</span>
        </label>
      </div>
    </div>
    
    

  
    <button class="btn btn-primary" @click="updateUser">更新</button>
    <button class="btn btn-danger" @click="showConfirm = true" v-if="rowData.is_superuser === false">刪除</button>
    <button class="btn btn-info" @click="showPasswordChange = true">變更密碼</button>
    <Confirm v-show="showConfirm" :message="'確定刪除此使用者?'" v-on:response="confirmDel"/>
    <password-change v-if="showPasswordChange" :userId="rowData.id" v-on:closePanel="closePanel" />

  </div>
</template>

<script>
import { systemType } from '@/config';
import PasswordChange from '@/components/common/PasswordChange';
import Confirm from '@/components/common/Confirm';

export default {
  name: 'UserDetail',
  data() {
    return {
      Data: '',
      jobTitle: [],
      departments: [],
      serverPrivilege2Group: [],
      //medAppPrivilegeGroup: [],
      //taskPrivilegeGroup: [],
      firstName: null,
      lastName: null,
      //email: null,
      title: null,
      department: null,
      serverPrivilege2: '',
      //medAppPrivilege: null,
      //taskPrivilege: null,
      barcode: null,
      isAdmin: false,
      isSuperuser: false,
      showPasswordChange: false,
      showConfirm: false,
      systemType,
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  components: {
    PasswordChange,
    Confirm,
  },
  async created() {
    this.Data = this.rowData;
    this.getJobTitle();
    this.getDepartment();
    await this.getServerPrivilege2Group();
    this.serverPrivilege2 = this.rowData.server_privilege2.id;
    //if (this.systemType === 'ADC') {
      //await this.getMedAppPrivilegeGroup();
      //await this.getTaskPrivilegeGroup();
      // await this.getServerPrivilegeGroup();
      // this.serverPrivilege = this.rowData.server_privilege.id;
      //if (this.rowData.med_app_privilege !== null) {
      //  this.medAppPrivilege = this.rowData.med_app_privilege.id;
      //}
      //if (this.rowData.med_app_privilege !== null) {
      //  this.taskPrivilege = this.rowData.task_privilege.id;
      //}
    //}
    this.firstName = this.rowData.first_name;
    this.lastName = this.rowData.last_name;
    //this.email = this.rowData.email;
    this.barcode = this.rowData.barcode;
    this.isAdmin = this.rowData.is_admin;
    this.isSuperuser = this.rowData.is_superuser;
    this.title = this.rowData.title.id;
    this.department = this.rowData.department.id;
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  methods: {
    putIntoData(response, data) {
      response.data.forEach((item) => {
        this[data].push(item);
      });
    },
    pushToCheckData(item, checkedData) {
      Object.entries(item).forEach((i) => {
        const attrName = i[0];
        const attrValue = i[1];

        if (attrName !== 'id' && attrName !== 'id') {
          if (attrValue) {
            checkedData.push(attrName);
          }
        }
      });
    },
    getDepartment() {
      return this.instance.get('/api/department/')
      .then((res) => {
        this.putIntoData(res, 'departments');
      });
    },
    getJobTitle() {
      return this.instance.get('/api/job-title/')
      .then((res) => {
        this.putIntoData(res, 'jobTitle');
      });
    },
    getServerPrivilege2Group() {
       return this.instance.get('/api/server-privilege2/')
       .then((res) => {
         this.putIntoData(res, 'serverPrivilege2Group');
       });
    },
    /*
    getTaskPrivilegeGroup() {
      return this.instance.get('/api/task-privilege/')
      .then((res) => {
        this.putIntoData(res, 'taskPrivilegeGroup');
      });
    },
    getMedAppPrivilegeGroup() {
      return this.instance.get('/api/med-app-privilege/')
      .then((res) => {
        this.putIntoData(res, 'medAppPrivilegeGroup');
        // this.medAppPrivilegeGroup.forEach((item) => {
        //   if (item.id === this.rowData.med_app_privilege.id) {
        //     this.thisMedAppPrivilegeGroup = item;
        //     // this.pushToCheckData(item, this.checkedMedApp);
        //   }
        // });
      });
    },
    */
    updateUser() {
      this.instance.patch(`/api/user/${this.rowData.id}/`, {
        first_name: this.firstName,
        last_name: this.lastName,
        //email: this.email,
        department: this.department,
        title: this.title,
        server_privilege2: this.serverPrivilege2,
        //med_app_privilege: this.medAppPrivilege,
        //task_privilege: this.taskPrivilege,
        barcode: this.barcode,
        is_admin: this.isAdmin,
        is_superuser: this.isSuperuser,
      })
      .then(() => {
        this.$parent.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });
        this.$parent.refresh();
      })
      .catch((err) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data,
        });
      });
    },
    confirmDel(res) {
      if (res) this.deleteUser();
      this.showConfirm = false;
    },
    deleteUser() {
      this.instance.delete(`/api/user/${this.rowData.id}/`)
      .then((res) => {
        this.$parent.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '刪除成功',
        });
      });
    },
    closePanel() {
      this.showPasswordChange = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// UserDetail.vue?18f7b956